"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CategoryTimeSeriesData_1 = __importDefault(require("./CategoryTimeSeriesData"));
class SalesByCategoryData {
    constructor({ 
    // hourly,
    daily, weekly, monthly, }) {
        this.toJSON = () => ({
            // hourly: this.hourly,
            daily: this.daily,
            weekly: this.weekly,
            monthly: this.monthly,
        });
        // this.hourly = hourly;
        this.daily = daily;
        this.weekly = weekly;
        this.monthly = monthly;
    }
}
SalesByCategoryData.fromJSON = (json) => {
    const { daily, weekly, monthly } = Object.assign({}, json);
    // if (!Array.isArray(hourly)) throw new Error('.hourly must be an array');
    if (!Array.isArray(daily))
        throw new Error('.daily must be an array');
    if (!Array.isArray(weekly))
        throw new Error('.weekly must be an array');
    if (!Array.isArray(monthly))
        throw new Error('.monthly must be an array');
    // const _hourly = hourly.map(item => CategoryTimeSeriesData.fromJSON(item));
    const _daily = daily.map(item => CategoryTimeSeriesData_1.default.fromJSON(item));
    const _weekly = weekly.map(item => CategoryTimeSeriesData_1.default.fromJSON(item));
    const _monthly = monthly.map(item => CategoryTimeSeriesData_1.default.fromJSON(item));
    return new SalesByCategoryData({
        // hourly: _hourly,
        daily: _daily,
        weekly: _weekly,
        monthly: _monthly,
    });
};
exports.default = SalesByCategoryData;
